<template>
  <q-list padding>
    <!-- Dashboard -->
    <DashboardMenu :dashboardLink="dashboardLink" />

    <!-- Favourite Menu -->
    <FavouriteMenuComponent :favMenu="favMenu" />

    <!-- Circuit Setup Zone -->
    <circuitSetupMenu :circuitSetup="circuitSetup" />

    <!-- bulk Transaction Zone -->
    <bulkTransactionMenu :bulkTransactionZone="bulkTransactionZone" />

    <!-- player Zone -->
    <PlayerZone :playerZone="playerZone" />

    <!-- Market Zone -->
    <MarketZoneMenu :marketZone="marketZone" />

    <!-- Market Depth Zone -->
    <MarketDepthZoneMenu :marketDepthZone="marketDepthZone" />

    <!-- Signal Zone  -->
    <signalZoneMenu :signalZone="signalZone" />

    <!-- Broker Zone -->
    <BrokerZoneMenu :brokerZone="brokerZone" />

    <!-- Accumulation Distribution Zone -->
    <AccumulationDistributionMenu
      :accumulationDistribution="accumulationDistribution"
    />

    <!-- Nepse Zone -->
    <NepseZoneMenu
      :multipleChartLayout="multipleChartLayout"
      :technicalZone="technicalZone"
      :nepseChart="nepseChart"
    />

    <!-- Trading Signals And Types -->
    <TradingSignalsAndTypes :signalTradingAndTypes="signalTradingAndTypes" />

    <!-- Pro Scanning & Backtesting Zone -->
    <ProScanningAndBackTest
      :savedCustomSignalV2ResultData="savedCustomSignalV2ResultData"
      :ProScanningZone="ProScanningZone"
    />

    <!-- Mutual Fund -->
    <MutualFundZoneMenu :MutualFundZone="MutualFundZone" />

    <!-- Fudamental Zone -->
    <FundamentalZoneMenu :fundamentalZone="fundamentalZone" />

    <!-- Technical Zone -->
    <TechnicalZoneMenu :technicalZone="technicalZone" />

    <!-- Utility Zone -->
    <UtilityZoneMenu :utilityZone="utilityZone" />

    <!-- Portfolio Zone -->
    <PortfolioZoneMenu :portfolioZone="portfolioZone" />
    <!-- Notification -->
    <NotificationZoneMenu :notificationZone="notificationZone" />

    <!-- IPOS and Auction Zone -->
    <IpoAndAuctionZoneMenu :ipoAndAuction="ipoAndAuction" />

    <!-- Educational Zone -->
    <EducationalZoneMenu :educationalZone="educationalZone" />

    <!-- Contact Us Zone -->
    <!-- :chukulTraining="chukulTraining" -->
    <OthersMenu
      :pricing="pricing"
      :mobileLinks="mobileLinks"
      :extraLinks="extraLinks"
      :PromoterBid="PromoterBid"
      :infoButtons="infoButtons"
      :isCapacitor="isCapacitor"
      :contactUsZone="contactUsZone"
    />
  </q-list>
</template>

<script>
import { defineComponent, ref, computed, watch } from "vue";
import useCustomsignal from "src/use/customsignal";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import DashboardMenu from "src/components/MainMenu/DashboardMenu.vue";
import FavouriteMenuComponent from "src/components/MainMenu/FavouriteMenu.vue";
import circuitSetupMenu from "src/components/MainMenu/CircuitSetupMenu.vue";
import bulkTransactionMenu from "src/components/MainMenu/BulkTransactionZone.vue";
import PlayerZone from "src/components/MainMenu/PlayerZone.vue";
import MarketZoneMenu from "src/components/MainMenu/MarketZoneMenu.vue";
import MarketDepthZoneMenu from "src/components/MainMenu/MarketDepthZoneMenu.vue";
import SignalZoneMenu from "src/components/MainMenu/SignalZoneMenu.vue";
import BrokerZoneMenu from "src/components/MainMenu/BrokerZoneMenu.vue";
import AccumulationDistributionMenu from "src/components/MainMenu/AccumulationDistributionMenu.vue";
import NepseZoneMenu from "src/components/MainMenu/NepseZoneMenu.vue";
import TradingSignalsAndTypes from "src/components/MainMenu/TradingSignalsAndTypes.vue";
import ProScanningAndBackTest from "src/components/MainMenu/ProScanningAndBackTest.vue";
import MutualFundZoneMenu from "src/components/MainMenu/MutualFundZoneMenu.vue";
import FundamentalZoneMenu from "src/components/MainMenu/FundamentalZoneMenu.vue";
import TechnicalZoneMenu from "src/components/MainMenu/TechnicalZoneMenu.vue";
import UtilityZoneMenu from "src/components/MainMenu/UtilityZoneMenu.vue";
import PortfolioZoneMenu from "src/components/MainMenu/PortfolioZoneMenu.vue";
import NotificationZoneMenu from "src/components/MainMenu/NotificationZoneMenu.vue";
import IpoAndAuctionZoneMenu from "src/components/MainMenu/IpoAndAuctionZoneMenu.vue";
import EducationalZoneMenu from "src/components/MainMenu/EducationalZoneMenu.vue";
import OthersMenu from "src/components/MainMenu/OthersMenu.vue";

export default defineComponent({
  name: "MainMenu",
  components: {
    DashboardMenu,
    FavouriteMenuComponent,
    circuitSetupMenu,
    bulkTransactionMenu,
    PlayerZone,
    MarketZoneMenu,
    MarketDepthZoneMenu,
    SignalZoneMenu,
    BrokerZoneMenu,
    AccumulationDistributionMenu,
    NepseZoneMenu,
    TradingSignalsAndTypes,
    ProScanningAndBackTest,
    MutualFundZoneMenu,
    FundamentalZoneMenu,
    TechnicalZoneMenu,
    UtilityZoneMenu,
    PortfolioZoneMenu,
    NotificationZoneMenu,
    IpoAndAuctionZoneMenu,
    EducationalZoneMenu,
    OthersMenu,
  },
  props: {
    market: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  setup(props) {
    const isMarket = ref(props.market);
    const $store = useStore();
    const isCapacitor = ref(process.env.IS_CAPACITOR);
    const { getSavedCustomSignalV2savedModels } =
      useCustomsignal();
    // const savedCustomSignalData = ref([]);
    const savedCustomSignalV2ResultData = ref([]);
    const router = useRouter();
    const favouriteMenu = ref([]);

    const favMenu = computed(() => {
      return [
        {
          icon: "settings",
          text: "Edit Favourite Menu",
          name: "FavouriteMenu",
        },
        ...$store.state.menu.generalMenu.filter((i) => i.favourite),
      ];
    });

    const signalTradingAndTypes = computed(() => {
      let signalTrading = [
        {
          icon: "airline_stops",
          text: "Mean Reversion Signals",
          name: "MeanReversalSignal",
        },
        {
          icon: "candlestick_chart",
          text: "Price Action Signals",
          name: "PriceActionSignals",
        },

        {
          icon: "alt_route",
          text: "Divergence Signals",
          name: "Divergence",
        },
        {
          icon: "trending_up",
          text: "Dow Signals",
          name: "DowSignals",
        },
        // {
        //   icon: "trending_up",
        //   text: "Trending Following Signals",
        //   name: "",
        // },
        // {
        //   icon: "bolt",
        //   text: "Momentum Breakout Signals",
        //   name: "",
        // },
      ];
      return signalTrading;
    });

    const openURL = (link) => {
      window.open(link);
    };
    
    getCustomSignalV2SavedModels();
    watch(
      () => $store.state.custom.saveModelSubmited,
      (newVal, oldVal) => {
        getCustomSignalV2SavedModels();
      }
    );
    function getCustomSignalV2SavedModels() {
      getSavedCustomSignalV2savedModels()
        .then((res) => {
          savedCustomSignalV2ResultData.value = res.data;
        })
        .catch((error) => {});
    }

    function openCustomSignalPro(link) {
      router.push({
        name: "CustomSignalProResults",
        query: {
          model: link.name,
        },
      });
    }

    const multipleChartLayout = ref([
      {
        icon: "view_agenda",
        text: "Two charts layout",
        name: "TwoChartsLayout",
      },
      {
        icon: "auto_awesome_mosaic",
        text: "Three charts layout",
        name: "ThreeChartsLayout",
      },
      {
        icon: "window",
        text: "Four charts layout",
        name: "FourChartsLayout",
      },
      {
        icon: "window",
        text: "Five charts layout",
        name: "FiveChartsLayout",
      },
      {
        icon: "view_module",
        text: "Six charts layout",
        name: "SixChartsLayout",
      },
    ]);
    const dashboardLink = ref([
      { icon: "home", text: "Dashboard", name: "Dashboard" },
    ]);
    // const chukulTraining = ref([
    //   { icon: "book", text: "Book Your Training", name: "ChukulTraining" },
    // ]);
    const notificationZone = ref([
      {
        icon: "person_pin",
        text: "User Notification",
        name: "UserNotification",
      },
      {
        icon: "public",
        text: "General Notification",
        name: "GeneralNotification",
      },
    ]);
    const MutualFundZone = ref([
      {
        icon: "shopping_basket",
        text: "Mutual Fund Matrix",
        name: "MutualFundMatrix",
      },
    ]);
    const portfolioZone = ref([
      {
        icon: "web",
        text: "Web Meroworth",
        url: "https://meroworth.com/#/",
        name: "meroworthlink",
      },
      {
        icon: "apple",
        text: "IOS MeroWorth",
        url: "https://apps.apple.com/us/app/meroworth/id6448978825",
        name: "meroworthlink",
      },
      {
        icon: "android",
        text: "Android MeroWorth",
        url: "https://play.google.com/store/apps/details?id=com.meroworth.app",
        name: "meroworthlink",
      },
    ]);
    const signalZone = ref([
      {
        icon: "view_carousel",
        text: "My Signals",
        name: "MySignals",
      },
      {
        icon: "view_day",
        text: "Daily Signal",
        name: "DailySignal",
      },
      {
        icon: "view_week",
        text: "Weekly Signal",
        name: "WeeklySignal",
      },
      // {
      //   icon: "candlestick_chart",
      //   text: "Price Action Signals",
      //   name: "PriceActionSignals",
      // },
      {
        icon: "trending_up",
        text: "Chukul Performance ",
        name: "ChukulPerformance",
      },
    ]);
    const ProScanningZone = ref([
      {
        icon: "view_day",
        text: "Custom Signal Pro",
        name: "CustomSignalProV2",
      },
      {
        icon: "save",
        text: "Custom Signal Pro Save",
        name: "CustomSignalProSave",
      },
      {
        icon: "speed",
        text: "Back Test Engine",
        name: "BackTestEngine",
      },
    ]);
    const accumulationDistribution = ref([
      {
        icon: "exposure",
        text: "Accumulation Distribution",
        name: "AccumulationDistribution",
      },
    ]);
    const circuitSetup = ref([
      {
        icon: "auto_awesome",
        text: "Live Hot Stock",
        name: "LiveHotStock",
      },
      {
        icon: "airline_stops",
        text: "Live Circuit Range",
        name: "CircuitSetup",
      },
      {
        icon: "dvr",
        text: "Live Probable Circuit List",
        name: "ProbableCircuitSetup",
      },
      {
        icon: "center_focus_strong",
        text: "Live Strong Buy/Sell",
        name: "LiveStrongBuySellList",
      },
      {
        icon: "center_focus_weak",
        text: "Live Weak Buy/Sell",
        name: "LiveWeakBuySellList",
      },
      {
        icon: "ssid_chart",
        text: "Live Volatile Stock",
        name: "LiveVolatileStock",
      },
    ]);
    const bulkTransactionZone = ref([
      {
        icon: "table_view",
        text: "Live Bulk Txn (Individual)",
        name: "LiveBulkTransaction",
      },
      // {
      //   icon: "dvr",
      //   text: "Live Bulk Txn (Mkt Opt)",
      //   name: "LiveBulkTransactionWithMarket",
      // },
      {
        icon: "queue",
        text: "Live Bulk Txn (Mkt opt Buy/Sell)",
        name: "LiveBulkTransactionWithMarketBuySell",
      },
      {
        icon: "backup_table",
        text: "Bulk Txn Pro",
        name: "BulkTransactionPro",
      },
      {
        icon: "legend_toggle",
        text: "Bulk Tnx with Circuit Setup",
        name: "BulkTnxCircuitSetup",
      },
      // {
      //   icon: "backup_table",
      //   text: "Bulk Txn Daywise (Mkt Opt)",
      //   name: "BulkTransactionDayswise",
      // },
      // {
      //   icon: "perm_contact_calendar",
      //   text: "Players Favourite Daywise",
      //   name: "PlayerFavouriteDays",
      // },
    ]);

    const playerZone = ref([
      {
        icon: "follow_the_signs",
        text: "Live Players Favourite",
        name: "PlayerFavourite",
      },
      {
        icon: "switch_account",
        text: "Players Favourite Pro",
        name: "PlayerFavouritePro",
      },
      {
        icon: "perm_contact_calendar",
        text: "Players Choice",
        name: "PlayerChoice",
      },
    ]);

    const ipoAndAuction = ref([
      {
        icon: "storefront",
        text: "IPO And Auction",
        name: "IposAndAuction",
      },
    ]);
    const marketZone = ref([
      {
        icon: "attach_money",
        text: "Live Market",
        name: "NepseLiveMarket",
      },
      {
        icon: "monetization_on",
        text: "Ltp Vs Close",
        name: "LtpVsClose",
      },
      {
        icon: "insights",
        text: "Market Summary",
        name: "NepseMarketSummary",
      },
      {
        icon: "view_carousel",
        text: "Custom Market Summary",
        name: "CustomNepseMarketSummary",
      },
      {
        icon: "add_business",
        text: "Sector Sentiment",
        name: "SectorSentiment",
      },
      {
        icon: "account_tree",
        text: "Live TreeMap",
        name: "TreeMap",
      },

      // {
      //   icon: "grid_on",
      //   text: "Floorsheet (V1)",
      //   name: "TodayFloorsheetV1",
      // },
      {
        icon: "grid_on",
        text: "Floorsheet",
        name: "TodayFloorsheet",
      },

      {
        icon: "campaign",
        text: "Announcement",
        name: "AnnouncementNews",
      },
      // {
      //   icon: "business",
      //   text: "Sector Performance",
      //   name: "SectorPerformance",
      // },
      // {
      //   icon: "compare",
      //   text: "Stock Performance",
      //   name: "StockPerformance",
      // },
      {
        icon: "filter_1",
        text: "Stock Filter",
        name: "StockFilter",
      },
      {
        icon: "multiline_chart",
        text: "Market Cap",
        name: "MarketCap",
      },
    ]);
    const nepseChart = ref([
      {
        icon: "bar_chart",
        text: "Technical Charts",
        name: "NepalStockExchangeTechnicalCharts",
      },
    ]);
    const technicalZone = ref([
      {
        icon: "key",
        text: "Level Alert",
        name: "KeyValueAlert",
      },
      {
        icon: "auto_awesome",
        text: "Trend Filter",
        name: "TrendFilter",
      },

      {
        icon: "horizontal_rule",
        text: "Consolidating Stocks",
        name: "ConsolidatingStocks",
      },
      {
        icon: "multiline_chart",
        text: "Live Macd Cross",
        name: "LiveMacdCross",
      },
      {
        icon: "expand",
        text: "Live Volume Spike",
        name: "LiveVolumeSpike",
      },
      {
        icon: "trending_up",
        text: "Live Dow Singals",
        name: "LiveDow",
      },
    ]);
    const utilityZone = ref([
      {
        icon: "calculate",
        text: "Share Calculator",
        name: "ShareCalculator",
      },
      {
        icon: "business",
        text: "Consolidating Up Breakout",
        name: "ConsolidatingUpBreakout",
      },
      {
        icon: "business",
        text: "Consolidating Down Breakout",
        name: "ConsolidatingDownBreakout",
      },
      {
        icon: "business",
        text: "Inside Bar Up Breakout",
        name: "InsidebarUpBreakout",
      },
      {
        icon: "business",
        text: "Inside Bar Down Breakout",
        name: "InsidebarDownBreakout",
      },
      { icon: "business", text: "Trending Stocks", name: "TrendingStocks" },
      {
        icon: "grid_view",
        text: "Consolidating Stocks",
        name: "ConsolidatingStocks",
      },

      {
        icon: "ssid_chart",
        text: "Volatile Stocks",
        name: "VolatileStocks",
      },
      {
        icon: "crisis_alert",
        text: "Value At Risk",
        name: "ValueAtRisk",
      },
      {
        icon: "grid_view",
        text: "Trading Near 52 Week High-Low",
        name: "TradingNear52Week",
      },
      {
        icon: "trending_down",
        text: "Trading Below 120 Days Average",
        name: "TradingBelow120DaysAverage",
      },
      // {
      //   icon: "candlestick_chart",
      //   text: "Candlestick Type",
      //   name: "candleStickPattern",
      // },
      {
        icon: "view_carousel",
        text: "Custom Signals",
        name: "CustomSignalPage",
      },
    ]);
    const utilityZoneCustom = ref([
      [
        {
          icon: "view_carousel",
          text: "Custom Signals",
          name: "CustomSignalPage",
        },
        {
          icon: "candlestick_chart",
          text: "Candlestick Type",
          name: "candleStickPattern",
        },
      ],
    ]);
    const brokerZone = ref([
      {
        icon: "receipt",
        text: "Broker Transaction",
        name: "BrokerTransactionNew",
      },
      {
        icon: "trending_up",
        text: "Broker Favourite",
        name: "BrokerFavourite",
      },
      {
        icon: "troubleshoot",
        text: "Broker Analytics Pro",
        name: "BrokerAnalyticsPro",
      },
      {
        icon: "verified",
        text: "Broker Analytics",
        name: "BrokerAnalytics",
      },
      {
        icon: "date_range",
        text: "Broker Analytics Intraday",
        name: "BrokerAnalyticsIntraday",
      },
      {
        icon: "grid_view",
        text: "Top Brokers Top Holding",
        name: "TopBrokerTopHolding",
      },
      {
        icon: "business",
        text: "Top Brokers Top Released",
        name: "TopBrokerTopReleased",
      },
      {
        icon: "business",
        text: "Sectorwise Top Stocks",
        name: "SectorWiseTopStocksPage",
      },
      {
        icon: "analytics",
        text: "Broker Summary",
        name: "BrokerSummary",
      },
    ]);
    const fundamentalZone = ref([
      // { icon: "grid_view", text: "Sector Report", name: "SectorReportPage" },
      // { icon: "business", text: "Stock Profile", name: "StockProfile" },
      {
        icon: "lock",
        text: "Unlocked Promotors",
        name: "UnlockedPromotors",
      },
      {
        icon: "search",
        text: "Fundamental Scan Pro",
        name: "FundamentalScanPro",
      },
      {
        icon: "search",
        text: "Fundamental Scan",
        name: "FundamantalScan",
      },
      {
        icon: "compare_arrows",
        text: "Compare Stocks",
        name: "StockComparison",
      },
      // {
      //   icon: "compare_arrows",
      //   text: "Compare Stocks All",
      //   name: "StockComparisionAll",
      // },
      {
        icon: "trending_up",
        text: "Fair value Stocks",
        name: "TradingBelowFairValue",
      },
      {
        icon: "reorder",
        text: "Low Cap Company",
        name: "LowCapCompany",
      },
      // {
      //   icon: "auto_stories",
      //   text: "Cap Filter",
      //   name: "CapFilter",
      // },
      {
        icon: "difference",
        text: "Compare Dividends",
        name: "DividendHistoryComparison",
      },
      {
        icon: "history",
        text: "Dividend History",
        name: "DividendHistory",
      },

      {
        icon: "ssid_chart",
        text: "Growth Stocks",
        name: "GrowthAbove40Percent",
      },
    ]);

    const marketDepthZone = ref([
      {
        icon: "how_to_reg",
        text: "Register TMS Account",
        name: "TmsRegister",
      },
      // {
      //   icon: "trending_up",
      //   text: "Login",
      //   name: "TmsLogin",
      // },
      {
        icon: "visibility",
        text: "Add Watchlist for market depth",
        name: "TmsAddWatchlist",
      },
      {
        icon: "trending_up",
        text: "Live Multiple Market Depth",
        name: "TmsMarketDepth",
      },
    ]);

    if ($store.state.authenticate.isAuthenticated) {
      $store.dispatch("packages/getPackageStatus").then(() => {
        if (
          $store.state.packages.packageStatus?.current_package?.package_name ===
          "Platinum"
        ) {
          const index = fundamentalZone.value.findIndex(
            (item) => item.name === "StockComparison"
          );
          if (index !== -1) {
            fundamentalZone.value.splice(index + 1, 0, {
              icon: "compare_arrows",
              text: "Compare Stocks All",
              name: "StockComparisionAll",
            });
          }
        }
      });
    }

    const isStaff = async () => {
      if (!$store.state.accounts.whoAmI) {
        await $store.dispatch("accounts/whoAmI");
        return $store.state.accounts.whoAmI?.is_staff;
      }
      return $store.state.accounts.whoAmI?.is_staff;
    };
    if ($store.state.authenticate.isAuthenticated)
      isStaff().then((isStaff) => {
        if (isStaff) {
          marketDepthZone.value.push({
            icon: "auto_awesome",
            text: "Add Auto Buy/Sell",
            name: "AutoBuySell",
          });

          // technicalZone.value.push({
          //   icon: "horizontal_rule",
          //   text: "Live Macd Cross",
          //   name: "LiveMacdCross",
          // });
        }
      });
    return {
      favMenu,
      favouriteMenu,
      multipleChartLayout,
      dashboardLink,
      notificationZone,
      // savedCustomSignalData,
      savedCustomSignalV2ResultData,
      // getCustomSignal,
      isMarket,
      openURL,
      dropIcon: {
        expand: "navigate_next",
      },
      isCapacitor,
      // chukulTraining,
      MutualFundZone,
      signalTradingAndTypes,
      portfolioZone,
      signalZone,
      ProScanningZone,
      accumulationDistribution,
      circuitSetup,
      bulkTransactionZone,
      playerZone,
      ipoAndAuction,
      marketZone,
      nepseChart,
      technicalZone,
      utilityZone,
      utilityZoneCustom,
      brokerZone,
      fundamentalZone,
      marketDepthZone,
      mobileLinks: [
        {
          icon: "android",
          text: "Get the Android app",
          url: "https://play.google.com/store/apps/details?id=com.pitech.portfoliotracker",
        },
      ],
      pricing: [{ icon: "settings", text: "Pricing", name: "Payment" }],

      educationalZone: [
        {
          icon: "smart_display",
          text: "Video Tutorial",
          name: "VideoTutorial",
          // url: "https://www.youtube.com/playlist?list=PLzDYs2xxFT2fO_Y1EkPiO1xc0DulZDZ-E",
        },

        // { icon: "help", text: "FAQ", name: "FAQs" },
        // { icon: "picture_as_pdf", text: "Chukul Manual", name: "ChukulManual" },
      ],
      contactUsZone: [
        {
          icon: "connect_without_contact",
          text: "Contact Us",
          name: "contactUs",
        },
      ],

      extraLinks: [
        { icon: "settings", text: "Settings", name: "Settings" },
        { icon: "feedback", text: "Send Feedback", name: "ReportBug" },
      ],

      PromoterBid: [
        // {
        //   icon: "align_vertical_center",
        //   text: "Promoter For Sell",
        //   name: "PromoterBidding",
        // },
      ],

      infoButtons: [
        { text: "Terms and Conditions", name: "TermsConditions" },
        { text: "Privacy Policy", name: "PrivacyPolicy" },
        {
          text: `Chukul © ${new Date().getFullYear()}, by Pi Tech Private Limited`,
          url: "http://pitechinfo.com",
        },
        // { text: "Powered By - Moon Eye Investment" },
      ],
    };
  },
});
</script>
<style>
/* .bg-gradient {
  background: linear-gradient(to right, #81beb9, #b1d6d6, #81beb9);
} */
</style>
